import React, { useState, useEffect, useContext } from "react";
import classes from "../TrucksAvailable.module.css";
import { DateFormatter2, isMobile } from "../../../Constants";
import ProfileModal from "../../TransporterClientScreen/ProfileModal/ProfileModal";
import ReactTooltip from "react-tooltip";
import { Activity, currentRequestTimeStamp } from "../../../Constants";
import { closeModal } from "../../Indent/InvoiceV2/utils"
import mixpanel from "mixpanel-browser";
import { Urls } from "../../../Urls";
import { toast } from "react-toastify";
import Loader from "../../Loader";
import axios from "../../../Axios/Axios";
import { useHistory } from "react-router";
import { useMixPanelForTracking } from "../../../utils/TrackMixPanel";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../MyCompanyProfileContext";
const MoveToIndent = ({
  truck_enquiry_id = "",
  company_id = "",
  item = "",
  send_data = [],
  setsenddata = "",
  editmode = false,
  transporter_list,
  companyProfile = {},
  onSuccess,
}) => {
  const [rank_list, setRank_list] = useState([]);
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const isApprover = companySettingData?.enquiry?.enquiry_approvers?.some(
    (u) => u.email === userDetails?.email
  );
  const enquiryTransition = companySettingData?.enquiry?.enquiry_transition === "yes";
  // const [interestedlist, setList] = useState([])
  const [transporterlist, settransporterlist] = useState([]);
  const [fetchedTransporters, setFetchedTransporters] = useState(transporter_list || []);
  const [show, setshow] = useState(false);
  const [step, setstep] = useState(0);
  const history = useHistory();
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);
  const [indentDop, setIndentDop] = useState("");
  const [indentStartTime, setIndentStartTime] = useState("");
  const [indentEndTime, setIndentEndTime] = useState("");
  const [isDopInvalid, setIsDopInvalid] = useState(false);
  const [dopChoice, setDopChoice] = useState("");


  /**
   * This effect runs when the component mounts.
   * It tracks user activity and initializes transporter-related data.
   */
  const [enquiryData, setEnquiryData] = useState(item || {});

  useEffect(() => {
    // Track user activity
    Activity([
      {
        screen: "LoRRI Adhoc",
        module: "My Enquiry",
        user_activity: `User has clicked on move to indent button`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);

    const enquiryId = item?.truck_enquiry_id || truck_enquiry_id;
    if (!enquiryId) return;

    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - move to indent",
      Data: `lane: ${item && item.lane_details?.origin && item.lane_details?.origin.location_name
        ? item.lane_details?.origin.location_name
        : ""
        } to ${item && item.lane_details?.destination && item.lane_details?.destination.location_name
          ? item.lane_details?.destination.location_name
          : ""
        }, truck type : ${item?.lane_details?.truck_types?.[0]?.label}`,
      Definition: `user moved an enquiry into an indent`,
    });

    setshow(true);
    axios.get(`${Urls.spot}?field=get_enquiry&truck_enquiry_id=${enquiryId}`)
      .then((res) => {
        const data = res.data;
        setEnquiryData(data);

        // Use transporter_rate_list from API if available, else fallback
        const fetched = data.transporter_rate_list ?? data.transporter_list ?? item?.transporter_list ?? [];
        const normalized = fetched.map(t => ({
          ...t,
          rate: t.current_quote?.rate || t.rate,
          main_status: t.current_quote?.main_status || t.main_status,
          is_shortlist: Boolean(t.is_shortlist || t.isChecked),
        }));

        normalized.forEach(t => {
          if (Array.isArray(t.rate_list) && t.rate_list.length > 0) {
            const last = t.rate_list[t.rate_list.length - 1];
            if (last && last.bid_status === 'negotiated') last.change = true;
          }
        });

        setFetchedTransporters(normalized);
        settransporterlist(normalized);

        const rates = [];
        normalized.forEach(t => {
          const r = parseInt(t.rate, 10);
          if (!Number.isNaN(r)) rates.push(r);
        });
        setRank_list([...new Set(rates)].sort((a, b) => a - b));

        // Check if DOP is in the past
        if (data?.lane_details?.due_date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const dopDate = new Date(data.lane_details.due_date);
          if (dopDate < today) {
            setIsDopInvalid(true);
            setDopChoice("");
            setIndentDop(new Date().toLocaleDateString('en-CA'));
          } else {
            setIndentDop(data.lane_details.due_date);
            setDopChoice("no");
          }
          setIndentStartTime(data.lane_details?.dop_start_time || "");
          setIndentEndTime(data.lane_details?.dop_end_time || "");
        }

      })
      .catch((err) => {
        console.error("Error fetching enquiry details:", err);
        // Fallback to item data if API fails
        const fetched = item?.transporter_list ?? [];
        const normalized = fetched.map(t => ({
          ...t,
          is_shortlist: Boolean(t.is_shortlist),
        }));
        setFetchedTransporters(normalized);
        settransporterlist(normalized);
      })
      .finally(() => setshow(false));
  }, [item?.truck_enquiry_id, truck_enquiry_id]);

  /**
   * Updates the shortlist status of a transporter.
   *
   * @param {boolean} value - Whether the transporter should be shortlisted.
   * @param {Object} transporter - The transporter object to update.
   */
  const shortlistransporter = (value, transporter) => {
    var temp = (fetchedTransporters || []).map((trans) => {
      if (trans.transporter_id === transporter.transporter_id) {
        trans.is_shortlist = value;
      }
      return trans;
    });
    // Update state with the modified transporter list
    settransporterlist(temp);
    setFetchedTransporters(temp);
  };

  /**
   * Checks if all transporters in the list are not shortlisted.
   *
   * @param {Array} transporterlist - List of transporters to check.
   * @returns {boolean} True if all transporters are not shortlisted, otherwise false.
   */
  const checklist = (transporterlist) => {
    if (transporterlist.length > 0) {
      var count = 0;
      for (var i = 0; i < transporterlist.length; i++) {
        if (
          !transporterlist[i].is_shortlist ||
          (transporterlist[i].is_shortlist &&
            transporterlist[i].is_shortlist === false)
        ) {
          count = count + 1;
        }
        if (i === transporterlist.length - 1) {
          if (count === transporterlist.length) {
            return true;
          }
        }
      }
      return false;
    } else {
      return true;
    }
  };

  /**
   * Submits the indent form and handles expiry date calculation if required.
   */
  const submitHandler = () => {
    // Check if transporters are selected
    if (checklist(transporterlist)) {
      toast.info("Please select transporter");
      return;
    }

    if (isDopInvalid && !dopChoice) {
      toast.info("Please select an option for the expired Date of Placement");
      return;
    }

    if (isDopInvalid && dopChoice === 'yes' && (!indentDop || indentDop < new Date().toLocaleDateString('en-CA'))) {
      toast.info("Please select a valid Date of Placement (Today or Future)");
      return;
    }

    const finalDop = (isDopInvalid && dopChoice === "no")
      ? (enquiryData.lane_details?.due_date || item.lane_details?.due_date)
      : indentDop;
    const finalStartTime = (isDopInvalid && dopChoice === "no") ? "" : indentStartTime;
    const finalEndTime = (isDopInvalid && dopChoice === "no") ? "" : indentEndTime;

    var indent = {
      truck_enquiry_id: enquiryData.truck_enquiry_id || item.truck_enquiry_id,
      indent_created: true,
      indent_dop: finalDop,
      indent_start_time: finalStartTime,
      indent_end_time: finalEndTime,
      transporter_ids: transporterlist
        .filter((t) => t.is_shortlist === true)
        .map((t) => t.transporter_id),
    };


      setshow(true);

      // Calculate expiry date if auto-expiry is enabled
      if (
        companyProfile &&
        companyProfile.indent &&
        companyProfile.indent.indent_expiry &&
        companyProfile.indent.indent_auto_expiry_enable === "yes"
      ) {
        var expiryhours = companyProfile.indent.indent_expiry;
        var expirydate = new Date();
        var hr = expirydate.getHours();
        expirydate.setHours(hr + parseInt(expiryhours));
        var day = expirydate.getDate();
        var month = ("0" + (expirydate.getMonth() + 1)).slice(-2);
        var year = expirydate.getFullYear();
        var final_hr = ("0" + expirydate.getHours()).slice(-2);
        var min = ("0" + expirydate.getMinutes()).slice(-2);
        var sec = ("0" + expirydate.getSeconds()).slice(-2);
        var expiry_date = `${year}-${month}-${day} ${final_hr}:${min}:${sec}.000000`;

        const shortlistedWithRank = transporterlist
          .filter((t) => t.is_shortlist === true)
          .map((t, idx) => ({
            ...t,
            rank: idx === 0 ? "L1" : t.rank,
          }));

        const newindents = [
          {
            destination: enquiryData.lane_details?.destination || item.lane_details?.destination,
            expiry_date: expiry_date,
            origin: enquiryData.lane_details?.origin || item.lane_details?.origin,
            placement_date: finalDop,
            shortlisted_transporters: shortlistedWithRank,
            truck_required: enquiryData.lane_details?.truck_required || item.lane_details?.truck_required,
            truck_types: Array.isArray(enquiryData.lane_details?.truck_types || item.lane_details?.truck_types)
              ? (enquiryData.lane_details?.truck_types || item.lane_details?.truck_types)
              : [enquiryData.lane_details?.truck_types || item.lane_details?.truck_types],
            from: "adhoc",
            display_indent_id: enquiryData.display_adhoc_id || item.display_adhoc_id,
            capacity: enquiryData.lane_details?.capacity || item.lane_details?.capacity,
            tonnage: enquiryData.lane_details?.tonnage || item.lane_details?.tonnage,
          },
        ];

        axios
          .post(`${Urls.spot}?field=edit_enquiry_v2`, indent)
          .then((res) => {
            if (res.data?.status === false) {
              toast.info(res.data?.message || "Indent is already created");
              setshow(false);
              return;
            }
            toast.success("Indent moved successfully");
            setstep(1);
            if (onSuccess) onSuccess();
            setshow(false);
          })
          .catch((e) => {
            console.log(e);
            setshow(false);
          });
      } else {
        // Prepare shortlisted transporters with rank assignment (L1 for the selected transporter)
        const shortlistedWithRank = transporterlist
          .filter((t) => t.is_shortlist === true)
          .map((t, idx) => ({
            ...t,
            rank: idx === 0 ? "L1" : t.rank,
          }));

        const newindent = [
          {
            destination: enquiryData.lane_details?.destination || item.lane_details?.destination,
            origin: enquiryData.lane_details?.origin || item.lane_details?.origin,
            placement_date: finalDop,
            shortlisted_transporters: shortlistedWithRank,
            truck_required: enquiryData.lane_details?.truck_required || item.lane_details?.truck_required,
            truck_types: Array.isArray(enquiryData.lane_details?.truck_types || item.lane_details?.truck_types)
              ? (enquiryData.lane_details?.truck_types || item.lane_details?.truck_types)
              : [enquiryData.lane_details?.truck_types || item.lane_details?.truck_types],
            from: "adhoc",
            display_indent_id: enquiryData.display_adhoc_id || item.display_adhoc_id,
            capacity: enquiryData.lane_details?.capacity || item.lane_details?.capacity,
            tonnage: enquiryData.lane_details?.tonnage || item.lane_details?.tonnage,
          },
        ];

        axios
          .post(`${Urls.spot}?field=edit_enquiry_v2`, indent)
          .then((res) => {
            if (res.data?.status === false) {
              toast.info(res.data?.message || "Indent is already created");
              setshow(false);
              return;
            }
            toast.success("Indent moved successfully");
            setstep(1);
            if (onSuccess) onSuccess();
            setshow(false);
          })
          .catch((e) => {
            console.log(e);
            setshow(false);
          });
    }
  };

  const renderedTransporterIds = new Set();

  return (
    <div>
      <Loader show={show} />

      <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
        {isMobile() ? (
          <div>
            <div className={classes["mob-transporter"]}>
              <div>
                <b>Origin: </b>
              </div>
              <div>
                <b>Transporter Name</b>
              </div>
              <div></div>
            </div>
          </div>
        ) : step === 0 ? (
          <>
            <table table-layout="fixed" className={`${classes["s-tablee"]}`}>
              <thead>
                <tr>
                  <th style={{ width: "25%", textAlign: "center" }}>Origin</th>
                  <th style={{ width: "25%", textAlign: "center" }}>
                    Destination
                  </th>
                  <th style={{ width: "15%", textAlign: "center" }}>
                    Truck Type
                  </th>
                  <th style={{ width: "15%", textAlign: "center" }}>
                    #Truck Required{" "}
                  </th>
                  <th style={{ width: "15%", textAlign: "center" }}>
                    Date of Placement
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {(enquiryData.lane_details?.origin || item.lane_details?.origin) ? (
                      <>
                        <i
                          className="fa fa-map-marker"
                          style={{ color: "#393186", marginRight: "1%" }}
                        />
                        <span
                          style={{ cursor: "pointer", paddingLeft: "5%" }}
                          data-tip
                          data-for={`origin`}
                        >
                          {(enquiryData.lane_details?.origin || item.lane_details?.origin).location &&
                            (enquiryData.lane_details?.origin || item.lane_details?.origin).location.location
                            ? (enquiryData.lane_details?.origin || item.lane_details?.origin).location.location
                            : (enquiryData.lane_details?.origin || item.lane_details?.origin).location_name}
                        </span>
                        <ReactTooltip
                          id={`origin`}
                          className={`${classes["tooltip"]}`}
                          place="bottom"
                          effect="float"
                          backgroundColor="#393185 !important"
                        >
                          {(enquiryData.lane_details?.origin || item.lane_details?.origin).location_name || ""}
                        </ReactTooltip>
                      </>
                    ) : (
                      "NA"
                    )}
                  </td>
                  <td>
                    {(enquiryData.lane_details?.destination || item.lane_details?.destination) ? (
                      <>
                        <i
                          className="fa fa-map-marker"
                          style={{ color: "#393186", marginRight: "1%" }}
                        />
                        <span
                          style={{ cursor: "pointer", paddingLeft: "5%" }}
                          data-tip
                          data-for={`destination`}
                        >
                          {(enquiryData.lane_details?.destination || item.lane_details?.destination).location &&
                            (enquiryData.lane_details?.destination || item.lane_details?.destination).location.location
                            ? (enquiryData.lane_details?.destination || item.lane_details?.destination).location.location
                            : (enquiryData.lane_details?.destination || item.lane_details?.destination).location_name}
                        </span>
                        <ReactTooltip
                          id={`destination`}
                          className={`${classes["tooltip"]}`}
                          place="bottom"
                          effect="float"
                          backgroundColor="#393185 !important"
                        >
                          {(enquiryData.lane_details?.destination || item.lane_details?.destination).location_name || ""}
                        </ReactTooltip>
                      </>
                    ) : (
                      "NA"
                    )}
                  </td>
                  <td>
                    {Array.isArray(enquiryData.lane_details?.truck_types || item.lane_details?.truck_types)
                      ? (enquiryData.lane_details?.truck_types || item.lane_details?.truck_types).map((trucks) => {
                        return trucks.label;
                      }).join(", ")
                      : (enquiryData.lane_details?.truck_types || item.lane_details?.truck_types)?.label}
                  </td>
                  <td>{(enquiryData.lane_details?.truck_required || item.lane_details?.truck_required) || ""}</td>
                  <td>{DateFormatter2(enquiryData.lane_details?.due_date || item.lane_details?.due_date)}</td>
                </tr>
              </tbody>
            </table>
            <br />
            {isDopInvalid && (
              <div style={{ marginBottom: "20px", padding: "10px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
                <h6 style={{ color: "#393186", marginBottom: "10px" }}>Date of Placement is in the past. Please select a new date and time.</h6>

                <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
                  <button
                    type="button"
                    className="btn btn-sm"
                    onClick={() => setDopChoice('yes')}
                    style={{
                      borderRadius: '20px',
                      padding: '5px 20px',
                      backgroundColor: dopChoice === 'yes' ? '#393186' : '#e0e0e0',
                      color: dopChoice === 'yes' ? 'white' : '#333',
                      border: 'none',
                      fontWeight: '500',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    Yes / Update Date of Placement
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm"
                    onClick={() => setDopChoice('no')}
                    style={{
                      borderRadius: '20px',
                      padding: '5px 20px',
                      backgroundColor: dopChoice === 'no' ? '#393186' : '#e0e0e0',
                      color: dopChoice === 'no' ? 'white' : '#333',
                      border: 'none',
                      fontWeight: '500',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    No / Continue with existing Date of Placement

                  </button>
                </div>

                {dopChoice === 'yes' && (
                  <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                    <div style={{ flex: "1", minWidth: "150px" }}>
                      <label style={{ display: "block", fontSize: "12px", color: "#666" }}>New DOP</label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={indentDop}
                        min={new Date().toLocaleDateString('en-CA')}
                        onChange={(e) => setIndentDop(e.target.value)}
                      />
                    </div>
                    <div style={{ flex: "1", minWidth: "100px" }}>
                      <label style={{ display: "block", fontSize: "12px", color: "#666" }}>Start Time</label>
                      <input
                        type="time"
                        className="form-control form-control-sm"
                        value={indentStartTime}
                        onChange={(e) => setIndentStartTime(e.target.value)}
                      />
                    </div>
                    <div style={{ flex: "1", minWidth: "100px" }}>
                      <label style={{ display: "block", fontSize: "12px", color: "#666" }}>End Time</label>
                      <input
                        type="time"
                        className="form-control form-control-sm"
                        value={indentEndTime}
                        onChange={(e) => setIndentEndTime(e.target.value)}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
            <div>
              <h5>Shortlist Transporters</h5>

              <hr />
              <table>
                <thead>
                  <tr style={{ border: "none" }}>
                    <th style={{ border: "none" }}>Transporter Name</th>
                    {/* <th>Ratings</th> */}
                    <th style={{ border: "none" }}>Current Rank</th>
                    <th style={{ border: "none" }}>Quotation Rate</th>
                    <th style={{ border: "none" }}>Status</th>
                  </tr>
                </thead>
                <tbody style={{ height: "10vh", overflowY: "scroll" }}>
                  {Array.isArray(fetchedTransporters) && fetchedTransporters.length > 0 ? (
                    fetchedTransporters.map((transporter) => {
                      const showTransporter = (rl) => (
                        <tr style={{ border: "none" }} key={`${transporter.transporter_id}-${rl?.bid_status || 'rate'}`}>
                          <td style={{ border: "none" }}>
                            <div style={{ display: "flex", padding: "0 3%" }}>
                              <div style={{ alignSelf: "center" }}>
                                <input
                                  type="checkbox"
                                  style={{ height: "15px", width: "15px" }}
                                  checked={transporter.is_shortlist}
                                  onChange={(e) => shortlistransporter(e.target.checked, transporter)}
                                />
                              </div>
                              <div style={{ flexBasis: "90%" }}>
                                <ProfileModal
                                  transporter_id={transporter.transporter_id}
                                  transporter_name={transporter.transporter_name}
                                  transporter_list={fetchedTransporters}
                                  screenName={"LoRRI Adhoc"}
                                  moduleName={"Adhoc to Indent"}
                                />
                              </div>
                            </div>
                          </td>
                          <td style={{ border: "none", textAlign: "left", paddingLeft: "4%" }}>
                            {rank_list && rank_list.length > 0
                              ? rank_list.map((rank, i) => {
                                if (rank === parseInt(transporter.rate)) {
                                  return <span key={i}>{i + 1}</span>;
                                }
                                return null;
                              })
                              : null}
                          </td>
                          <td style={{ border: "none", textAlign: "left", paddingLeft: "3%" }}>
                            {rl?.rate || transporter.rate || ""}
                          </td>
                          <td style={{ border: "none", textAlign: "left", color: "#54af3a" }}>
                            {transporter.main_status === "approved" || rl?.bid_status === "approved"
                              ? "Approved"
                              : rl?.bid_status === "accepted"
                                ? "Accepted"
                                : transporter.rate ? "Quoted" : ""}
                          </td>
                        </tr>
                      );

                      if (Array.isArray(transporter.rate_list) && transporter.rate_list.length > 0) {
                        const latestRate = transporter.rate_list[transporter.rate_list.length - 1];
                        
                        const isApproved = transporter.main_status === "approved" || latestRate.bid_status === "approved";
                        const isAccepted = latestRate.bid_status === "accepted";
                        
                        const shouldShow = isApproved || (isAccepted && !enquiryTransition);

                        if (shouldShow) {
                          if (renderedTransporterIds.has(transporter.transporter_id)) {
                            return null;
                          }
                          renderedTransporterIds.add(transporter.transporter_id);
                          return showTransporter(latestRate);
                        }
                        return null;
                      } else if (transporter.rate) {
                        const isApproved = transporter.main_status === "approved";
                        const shouldShow = isApproved || !enquiryTransition;


                        if (shouldShow) {
                          if (renderedTransporterIds.has(transporter.transporter_id)) {
                            return null;
                          }
                          renderedTransporterIds.add(transporter.transporter_id);
                          return showTransporter();
                        }
                      }
                      return null;
                    })
                  ) : <tr><td colSpan={4} style={{ border: "none" }}>No Transporter’s Selected</td></tr>}

                </tbody>
              </table>
              <br />
              <center>
                <button
                  className="btn btn-sm btn-success"
                  onClick={submitHandler}
                >
                  Submit
                </button>
              </center>
            </div>
          </>
        ) : (
          <div style={{ textAlign: "center", color: "#393186" }}>
            <div>
              <h3>Indent Created</h3>
            </div>
            <center>
              <a
                className="btn btn-sm btn-primary"
                target="_blank"
                onClick={(e) => {
                  Activity([
                    {
                      screen: "LoRRI Adhoc",
                      module: "Create Indent",
                      user_activity: "Go to Indent button Clicked",
                      timestamp: currentRequestTimeStamp(),
                    },
                  ]);
                  mixpanel.track(`User has clicked on indent button`, {
                    ApplicationName: `${Urls.mixpanelappname}`,
                    ScreenName: "LoRRI-Adhoc",
                    ModuleName: "my_enquiries",
                    ActivityLog: "userClickedGoToIndentButton",
                    Data: `Go to Indent button clicked`,
                    Definition: `User has clicked on Go to Indent button`,
                    ActivityType: "event_view",
                    UserName: `${localStorage.getItem("userdetails")}`,
                    UserEmail: `${localStorage.getItem("useremail")}`,
                    CompanyName: `${localStorage.getItem("companyname")}`,
                  });
                  history.push("/indentrequest");
                }}
              >
                Go to Indents
              </a>
            </center>
          </div>
        )}
      </div>
    </div>
  );
};

export default MoveToIndent;
